<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button">
          <i class="fas fa-bars"></i>
        </a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item" title="Xem toàn màn hình">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item dropdown" title="Thông tin cá nhân">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="fas fa-user"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header"> <i class="fas fa-user-gear mr-2"></i> {{ user != null ? user.fullname : "" }}</span>
          <div class="dropdown-divider"></div>
          
          <button class="dropdown-item" data-toggle="modal" data-target="#changePassModal">
            <i class="fas fa-key mr-2"></i> {{ $t('labels.changePassword')}}
          </button>
          
          <div class="dropdown-divider"></div>

          <button class="dropdown-item" data-toggle="modal" data-target="#changeProfileModal">
            <i class="fas fa-circle-info mr-2"></i> {{ $t('labels.changeInfo')}}
          </button>
          
          <div class="dropdown-divider"></div>
          
          <button class="dropdown-item" @click="onClickLogout()">
            <i class="fas fa-sign-out-alt mr-2"></i> {{ $t('labels.logout')}}
          </button>
        </div>
      </li>
    </ul>

    

  </nav>
  <!-- /.navbar -->
</template>

<script>
import { mapState, mapActions } from 'vuex';
import $ from 'jquery';
export default {
  name: 'TheNavBar',
  data(){
    
  },
  methods: {
    ...mapActions('authentication', ['logout']),
    onClickLogout() {
      this.logout();
      window.location.reload();
    }
  },
  computed: {
      ...mapState({
        user: state => state.authentication.user
      }),
  }
}
</script>

<style>

</style>